import React from 'react';
import { SubTitle } from 'components/uiParts/SubTitle';
import { CreateForm } from 'components/uiParts/Form/CreateForm';
import { Breadcrumb } from 'components/uiParts/Breadcrumb';
// 定数ファイル
import { CUSTOMER_CATEGORY_COLUMNS } from 'utils/constantsTable';
// MUI
import Button from '@mui/material/Button';

export const CustomerCategory3CreatePage = () => {
  const breadcrumbList = [
    { name: 'ダッシュボード', href: '/' },
    { name: '得意先区分3一覧', href: '/customerCategory3/list' },
    { name: '得意先区分3登録' },
  ];

  return (
    <>
      <Breadcrumb breadcrumbList={breadcrumbList} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <SubTitle title='得意先区分3登録' />
        <Button
          href={location.origin + '/customerCategory3/list'}
          variant='contained'
          color='inherit'
        >
          戻る
        </Button>
      </div>
      <CreateForm
        api='CustomerCategory3'
        columns={CUSTOMER_CATEGORY_COLUMNS}
        input={{
          name: '',
          remarks: '',
        }}
        redirectUrl='/customerCategory3/list'
      />
    </>
  );
};
